/* eslint-disable jsx-a11y/label-has-associated-control */
import { useForm } from 'react-hook-form';
import { useRouter } from 'next/router';
import cn from 'classnames';

import Button from '@/components/Button';

type Inputs = {
  email: string;
};

export default function HeroForm({ className }: { className?: string }) {
  const router = useRouter();
  const { register, handleSubmit, errors } = useForm<Inputs>();

  function onSubmit({ email }: Inputs) {
    if (!email) return;

    window.sessionStorage.setItem(`email`, email);
    router.push(`/contact`);
  }

  const hasError = !!errors.email;

  return (
    <>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={cn(
          `flex items-center flex-col md:flex-row w-full`,
          className,
        )}
      >
        <div className="w-full md:max-w-xs">
          <label
            htmlFor="email"
            className="block text-sm font-medium text-gray-700 sr-only"
          >
            Email
          </label>
          <div className="relative rounded-r md:rounded-r-none rounded-l">
            <input
              type="email"
              name="email"
              id="email"
              placeholder="Enter email"
              ref={register({
                required: true,
                pattern: {
                  value: /^\S+@\S+$/i,
                  message: `Invalid email`,
                },
              })}
              className="form-input block w-full px-4 md:px-6 focus:outline-none ring-0 border-none focus:ring-0 sm:text-sm rounded-r md:rounded-r-none rounded-l bg-catskill-white text-rock-blue"
              {...(hasError && {
                'aria-invalid': `true`,
                'aria-describedby': `email-error`,
              })}
            />
          </div>
        </div>
        <Button
          colour="purple"
          className="!px-6 rounded-r rounded-l md:rounded-l-none mt-3 md:mt-0 w-full md:w-auto"
          type="submit"
        >
          Request a demo
        </Button>
      </form>
      {hasError && (
        <p className="mt-2 text-sm text-red-600" id="email-error">
          Please enter a valid email address
        </p>
      )}
    </>
  );
}
